export default __webpack_public_path__ + "static/lefafa_1_4-cf7af240b6c68c78c743f2c47167e677.webp";